/**
 * assets/bundle-variant-selector.js
 *
 * Loaded as an external file (not an inline <script>) specifically so it
 * survives a Content-Security-Policy that blocks inline scripts but allows
 * same-origin external ones — a common silent failure mode: the browser
 * drops the script with no visible error on the page itself, only a CSP
 * violation line in the console that's easy to miss.
 *
 * Uses event delegation on `document` instead of getElementById, so it
 * works no matter how many .bundle_variant_section instances exist on the
 * page, and no matter when they're injected (AJAX filtering, quick view,
 * theme editor re-render).
 *
 * Overrides the variant value at the CAPTURE phase of click/submit — this
 * runs before other apps' bubble-phase listeners (e.g. a cart-drawer app)
 * get a chance to read the (still wrong) form value first.
 */
(function () {
  if (window.__bundleVariantSelectorLoaded) return;
  window.__bundleVariantSelectorLoaded = true;

  var SECTION = ".bundle_variant_section";
  var CARD = ".bundle_card";

  function getForm(section) {
    return section.closest(".shopify-section")?.querySelector('form[action*="/cart/add"]') ||
           document.querySelector('form[action*="/cart/add"]');
  }

  function getAddButton(section) {
    var scope = section.closest(".shopify-section") || document;
    return scope.querySelector('button[name="add"], [data-add-to-cart], .product-form__submit');
  }

  function setActive(section, variantId) {
    section.querySelectorAll(CARD).forEach(function (c) {
      var on = c.dataset.variantId === String(variantId);
      c.classList.toggle("active", on);
      c.setAttribute("aria-checked", on ? "true" : "false");
    });
    section.dataset.selectedVariant = variantId;
  }

  function forceInput(section, variantId) {
    var form = getForm(section);
    if (!form) return;
    var input = form.querySelector('input[name="id"]');
    if (!input) return;
    input.value = variantId;
    input.dispatchEvent(new Event("change", { bubbles: true }));
    input.dispatchEvent(new Event("input", { bubbles: true }));
  }

  function selectCard(card) {
    var section = card.closest(SECTION);
    if (!section) return;
    var variantId = card.dataset.variantId;
    if (!variantId) return;

    setActive(section, variantId);
    forceInput(section, variantId);

    try {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variantId);
      window.history.replaceState({}, "", url);
    } catch (e) {}

    section.dispatchEvent(new CustomEvent("bundle:variant-selected", {
      bubbles: true,
      detail: { variantId: variantId }
    }));
  }

  // Bubble-phase click just to pick the card (safe to run anywhere in order).
  document.addEventListener("click", function (e) {
    var card = e.target.closest(CARD);
    if (card && !card.classList.contains("sold-out")) selectCard(card);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    var card = e.target.closest(CARD);
    if (!card || card.classList.contains("sold-out")) return;
    e.preventDefault();
    selectCard(card);
  });

  // CAPTURE-phase safety net: right before the add-to-cart click is allowed
  // to reach ANY other listener (theme JS, cart-drawer app, etc.), re-assert
  // the correct variant id on the form input one more time.
  document.addEventListener("click", function (e) {
    var btn = e.target.closest('button[name="add"], [data-add-to-cart], .product-form__submit');
    if (!btn) return;
    var section = document.querySelector(SECTION);
    if (!section || !section.dataset.selectedVariant) return;
    forceInput(section, section.dataset.selectedVariant);
  }, true);

  // CAPTURE-phase safety net on form submit itself — covers Buy Now /
  // dynamic checkout buttons and any app that submits the form
  // programmatically rather than via a click on the visible button.
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf("/cart/add") === -1) return;
    var section = document.querySelector(SECTION);
    if (!section || !section.dataset.selectedVariant) return;
    var input = form.querySelector('input[name="id"]');
    if (input) input.value = section.dataset.selectedVariant;
  }, true);

  // Reflect external variant changes (back button, other UI) back onto the cards.
  document.addEventListener("change", function (e) {
    if (!e.target.matches('input[name="id"]')) return;
    var section = document.querySelector(SECTION);
    if (section) setActive(section, e.target.value);
  });
})();